import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import GeneralCarousel from '../general-carousel/GeneralCarousel';
import Title from '../title/Title';
import EirButton from '../eir-button/EirButton';
import Subtitle from '../subtitle/Subtitle';
import { isMobile, isTablet } from "react-device-detect";

class TwoFourColumn extends Component {
  constructor(props) {
   super(props);
  }

  getCarouselImages() {
    let images = []

    this.props.tiles.map(tile => {
      let o = []
      o.src = tile.imageMobile.path
      images.push(o)
      //images.push(tile.image.path)
    });

    return images;

  }

  // Need to think of a more elegant way to do this
  // Doing it for now, to try and keep GeneralCarousel "general"
  getCarouselText() {
    let texts = []

    this.props.tiles.map(tile => {
      let o = []
      o = tile.text
      texts.push(o)
      //images.push(tile.image.path)
    });

    return texts;

  }
  getBackgroundImage(){
    if (isMobile && !isTablet) {
    return this.props.imageMobile.path
    }
    return this.props.image.path
    }
    // eir-1597
    getCarouselTextHeading() {
      let textHeadings = []
  
      this.props.tiles.map(tile => {
        let o = []
        o = tile.title
        textHeadings.push(o)
        //images.push(tile.image.path)
      });
  
      return textHeadings;
  
    }

  render() {
        let colWidth = " col-md-" + (12 / this.props.tiles.length)
    return (
      <Container fluid={this.props.fluid} className={'eir-two-four-column for-zoomin-zoomout mb-6 mt-md-5' + (this.props.theme ? ' eir-theme-' + this.props.theme : ' eir-theme-default')}>
      <div
          className="two-four-main" 
          style={{ 
          backgroundImage: "url(" + this.getBackgroundImage() + ")",
          // backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          padding: '15px 0'
          }}
          >
      {/* eir-1597 */}
      <div className="whybuy-carousel">
        <div className="general-carousel-container d-md-none text-center">
            <GeneralCarousel 
              items={this.getCarouselImages()} 
              textHeading={this.getCarouselTextHeading()}
              optionalText={this.getCarouselText()}>
            </GeneralCarousel>
        </div>
      </div>
        <Row className={ (this.props.tiles.length == 2) ? 'd-none d-md-flex why-buy-two-image' : 'd-none d-md-flex'}>
          {this.props.tiles.map(tile => {
            return (
              <Col className={"text-center mb-4 pl-4 pr-4" + colWidth}>

                {tile.image &&
                  <Container className="p-0">
                    <div className="d-flex flex-column justify-content-center align-items-center">
                  {/*}    <img className="img-fluid mh-100 mh-100" src={tile.image.path} alt={tile.image.description} /> {*/}
                  <img intrinsicsize="300*200" className="two-four-img" src={tile.image.path} alt={tile.image.description}  />
                  </div>
                  </Container>
                }

                {(tile.title) ? <Title className={(this.props.tiles.length == 3) ? 'why-buy-copy-head' : 'why-buy-copy-head'} title={tile.title} />
                  :
                  <Title className={'why-buy-copy-head'} title={' '} />
                }

                {tile.text &&
                  <Subtitle className={(this.props.tiles.length == 3) ? 'justify-content-center why-buy-copy' : 'justify-content-center why-buy-copy'}  text={tile.text} />
                }

                {tile.cta &&
                  <EirButton {...tile.cta} />
                }
              </Col>
            );
          })
          }
        </Row>
        <Row className="justify-content-center">
          {this.props.bottomCTA &&
           <EirButton {...this.props.bottomCTA} />
          }
        </Row>
      </div> 
      </Container>

    );
  }
}

export default TwoFourColumn;

